import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DetailLayout } from "@/layouts/DetailLayout/DetailLayout";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { useGetTasksQuery } from "@/modules/tasks/components/hooks/useGetTasksQuery";
import { SubtaskItem } from "@/modules/tasks/components/SubtaskItem/SubtaskItem";
import { TaskItemsHeader } from "@/modules/tasks/components/TaskItemsHeader/TaskItemsHeader";
import { TaskLayoutDetails } from "@/modules/tasks/components/TaskLayoutDetails";
import { ParsedTasksItem } from "@/modules/tasks/types/types";
import { Deadline } from "@/modules/theme/components/Deadline/Deadline";
import { DetailLayoutBox } from "@/modules/theme/components/DetailLayoutBox";
import { PageLoader } from "@/modules/theme/components/Loader/PageLoader";

const translationNamespace = "pages/TaskDetailsPage";

export const TaskDetailsPage = () => {
  const { t } = useTranslation(translationNamespace);
  const [task, setTask] = useState<ParsedTasksItem | null>(null);
  const params = authenticatedRouting.useRouteParams("taskDetails");

  const {
    data: tasksData,
    isFetching: isTasksDataFetching,
  } = useGetTasksQuery();

  useEffect(() => {
    if (tasksData) {
      const pickedTask = tasksData.find(({ id }) => id === params?.id);
      setTask(pickedTask || null);
    }
  }, [tasksData, params?.id]);

  const toDoSubtasks = task?.subtasks.filter(({ done }) => !done);
  const doneSubtasks = task?.subtasks.filter(({ done }) => done);

  return (
    <>
      {isTasksDataFetching && <PageLoader />}
      {task && (
        <DetailLayout
          variant="task"
          heading={task.name}
          details={
            <>
              {task.deadline && <Deadline>{task.deadline}</Deadline>}
              <TaskLayoutDetails
                points={task.pointsNumber}
                groups={task.groups}
              />
            </>
          }
        >
          <DetailLayoutBox>
            {toDoSubtasks?.length ? (
              <>
                <TaskItemsHeader>{t("To Do")}</TaskItemsHeader>
                {toDoSubtasks.map(({ id, name, pointsNumber }) => (
                  <SubtaskItem
                    id={id}
                    key={id}
                    name={name}
                    pointsNumber={pointsNumber}
                  />
                ))}
              </>
            ) : null}

            {doneSubtasks?.length ? (
              <>
                <TaskItemsHeader>{t("Done")}</TaskItemsHeader>
                {doneSubtasks.map(({ id, name, pointsNumber, rating }) => (
                  <SubtaskItem
                    id={id}
                    key={id}
                    name={name}
                    pointsNumber={pointsNumber}
                    rating={rating}
                    done
                  />
                ))}
              </>
            ) : null}
          </DetailLayoutBox>
        </DetailLayout>
      )}
    </>
  );
};
